import { GzTabWebComponent } from './component/GzTabWebComponent';
import { WEB_COMPONENT_GZ_TAB } from '../../../webcomponents.constants';

export { GzTabWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TAB, GzTabWebComponent);
